import { BASE_API_URL } from "utils/constants";
import { get } from '../../utils/api';
import { DataResponse } from "../response";

// Kiểu dữ liệu api trả về của Chart
export type TotalCustomerModel = {
  name: string;
  total: number;
}
export type ArrayTotalCustomerModel = {
  name?: string[];
  total?: number[];
}
export type ValueCustomerModel = {
  name: string;
  value: number;
}
export type NowPreviousModel = {
  name: string;
  totalNow: number;
  totalPrevious: number;
}
export type ColLineModel = {
  name: string;
  totalCol: number;
  totalLine: number;
}

// Interface của Chart service
export interface IChartServices {
  // Lấy data tỉ lệ khách hàng theo loại
  getListCustomerType(companyCode: string): Promise<DataResponse<ValueCustomerModel[]>>;
  // Lấy data tỉ lệ khách hàng theo nhóm
  getlListPercentCustomerGroup(companyCode: string): Promise<DataResponse<ValueCustomerModel[]>>;
  // Lấy data số lượng nhóm khách hàng theo nhóm
  getListNumberCustomerGroup(companyCode: string): Promise<DataResponse<TotalCustomerModel[]>>;
  // Lấy data tỉ lệ khách hàng theo khu vực
  getListPercentCustomerSaleOffice(companyCode: string): Promise<DataResponse<ValueCustomerModel[]>>;
  // Lấy data số lượng khách hàng theo khu vực
  getListNumberCustomerSaleOffice(companyCode: string): Promise<DataResponse<TotalCustomerModel[]>>;
  // Lấy data top 10 tỉnh thành có số lượng khách hàng cao nhất
  getListTop10CustomerProvince(companyCode: string): Promise<DataResponse<TotalCustomerModel[]>>;
  // Lấy data số lượng khách hàng  thăm npp/srnq tháng này và tháng trước
  getListCustomerVisitingDistributers(companyCode: string): Promise<DataResponse<NowPreviousModel[]>>;
  // Lấy data số lượng khách hàng thăm showroom tháng này và tháng trước
  getListCustomerVisitingShowroom(companyCode: string): Promise<DataResponse<NowPreviousModel[]>>;
  // Lấy data tổng hợp điểm trưng bày
  getListShowroom(companyCode: string): Promise<DataResponse<ColLineModel[]>>;
  // Lấy data tổng hợp xử lý khiếu nại theo nhóm hàng
  getListProductIssueGroup(companyCode: string): Promise<DataResponse<ColLineModel[]>>;
  // Lấy data tổng hợp xử lý khiếu nại lỗi thường gặp
  getListProductIssueError(companyCode: string): Promise<DataResponse<ColLineModel[]>>;
  // Lấy data tổng hợp xuất nhập tồn catalog
  getListCatalog(companyCode: string): Promise<DataResponse<TotalCustomerModel[]>>;
  // Lấy data thị hiếu khách hàng đến showroom
  getListCustomerTastes(companyCode: string): Promise<DataResponse<TotalCustomerModel[]>>;
  // Lấy data tổng hợp thị hiếu sản phẩm
  getListStatisticLikeView(companyCode: string): Promise<DataResponse<TotalCustomerModel[]>>;
}

//Hàm khởi tạo các phương thức của Chart service
export function createChartServices(): IChartServices {
  return {
    // Lấy data tỉ lệ khách hàng theo loại
    getListCustomerType: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/customer-classification?${companyCode ? `companyCode=${companyCode}` : ''}`,
        )
      ).data
    },
    // Lấy data tỉ lệ khách hàng theo nhóm
    getlListPercentCustomerGroup: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/piechart-customer-group?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data số lượng nhóm khách hàng theo nhóm
    getListNumberCustomerGroup: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/barchart-customer-group?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data tỉ lệ khách hàng theo khu vực
    getListPercentCustomerSaleOffice: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/piechart-customer-byArea?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data số lượng khách hàng theo khu vực
    getListNumberCustomerSaleOffice: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/barchart-customer-byArea?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data top 10 tỉnh thành có số lượng khách hàng cao nhất
    getListTop10CustomerProvince: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/customer-top10-province?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data số lượng khách hàng thăm npp/srnq tháng này và tháng trước
    getListCustomerVisitingDistributers: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/customer-visiting-distributer?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data số lượng khách hàng thăm showroom tháng này và tháng trước
    getListCustomerVisitingShowroom: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/customer-visiting-showroom?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data tổng hợp thị hiếu sản phẩm
    getListStatisticLikeView: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/statistic-like-view?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data tổng hợp điểm trưng bày
    getListShowroom: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/showroom?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data tổng hợp xử lý khiếu nại theo nhóm hàng
    getListProductIssueGroup: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/product-issue-group?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data tổng hợp xử lý khiếu nại lỗi thường gặp
    getListProductIssueError: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/product-issue-error?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data thị hiếu khách hàng đến showroom
    getListCustomerTastes: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/customer-tastes?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },
    // Lấy data tổng hợp xuất nhập tồn catalog
    getListCatalog: async (companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Chart/catalog?${companyCode ? `companyCode=${companyCode}` : ``}`,
        )
      ).data
    },

  }
}
